<template>
  <div class="divJavaTitle">
    <h1 :style="{ color: titleColor }" v-if="title">
      <img src="../img/left.png" />{{ title }}<slot></slot
      ><img src="../img/right.png" />
    </h1>
    <p :style="{ color: subTitleColor }" v-if="subTitle">{{ subTitle }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "#000",
    },
    subTitleColor: {
      type: String,
      default: "rgba(109,109,109,1)",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/titleWidge.scss";
</style>
